import type { IAccountTransaction } from "@apis/accountTransactions/types"
import type { ColumnDef } from "@tanstack/react-table"
import { DateCell } from "@utils/table/columnFactories"

export const tableColumnsAccountTransactions: ColumnDef<IAccountTransaction>[] =
  [
    {
      accessorKey: "account_transaction_id",
      header: "Internal ID",
    },
    {
      accessorKey: "transaction_id",
      header: "Raw Transaction ID",
    },
    {
      accessorKey: "transaction_action_code",
      header: "Transaction Code",
    },
    {
      accessorKey: "transaction_qualifier",
      header: "Transaction Qualifier",
    },
    {
      accessorKey: "transaction_response_qualifier",
      header: "Transaction Response Qualifier",
    },
    {
      accessorKey: "reason_code",
      header: "Reason Code",
    },
    {
      accessorKey: "reason_description",
      header: "Reason Description",
    },
    {
      accessorKey: "transaction_date",
      header: "Transaction Date",
      cell: (props) => <DateCell {...props} />,
    },
    {
      accessorKey: "utility_name",
      header: "Utility",
    },
    {
      accessorKey: "account_number",
      header: "Account Number",
    },
  ]
